module.exports = __webpack_public_path__ + "static/media/islandWithPier.da6701f4.png";